<template>
  <div>
<!--    <tci-recruit allTitle subtitle="RECRUIT" :title="$t('recruit.mainPage.recruit_new')" :recruits="infos"></tci-recruit>-->
    <div>
      <tci-title :title="$t('recruit.mainPage.recruit_new')" subtitle="RECRUIT" color="white">
        <v-row :class='index%2==0?"grey lighten-2 pb-0":" pb-0"' v-for="(recruit,index) in recruitInfo" :key="recruit.name">
          <tci-recruit-card :title="title" :name="recruit.name" :position="recruit.position"
                            :email="recruit.email" :responses="recruit.responses" :requests="recruit.requests"
                            :practice="recruit.practice" allTitle="true"></tci-recruit-card>
        </v-row>
      </tci-title>
      <tci-title :title="$t('recruit.mainPage.recruit_dev')" subtitle=".NET DEVELOPMENT ENGINEER" color="white">
        <v-row :class='index%2==0?"grey lighten-2 pb-0":" pb-0"' v-for="(recruit,index) in recruitDeveloperInfo" :key="recruit.name">
          <tci-recruit-card :title="title" :name="recruit.name" :position="recruit.position" :salary="recruit.salary"
                            :email="recruit.email" :responses="recruit.responses" :requests="recruit.requests"
                            :practice="recruit.practice" :allTitle="true"></tci-recruit-card>
        </v-row>
      </tci-title>
      <tci-title :title="$t('recruit.mainPage.recruit_manager')" subtitle="PROJECT DEVELOPMENT LEADER" color="white">
        <v-row :class='index%2==0?"grey lighten-2 pb-0":" pb-0"' v-for="(recruit,index) in recruitManagerInfo" :key="recruit.name">
          <tci-recruit-card :title="title" :name="recruit.name" :position="recruit.position" :salary="recruit.salary"
                            :email="recruit.email" :responses="recruit.responses" :requests="recruit.requests"
                            :practice="recruit.practice" :allTitle="true"></tci-recruit-card>
        </v-row>
      </tci-title>
      <tci-title :title="$t('recruit.mainPage.recruit_sap')" subtitle="PROJECT MANAGER" color="white">
        <v-row :class='index%2==0?"grey lighten-2 pb-0":" pb-0"' v-for="(recruit,index) in recruitServerEngineerInfo" :key="recruit.name">
          <tci-recruit-card :title="title" :name="recruit.name" :position="recruit.position" :salary="recruit.salary"
                            :email="recruit.email" :responses="recruit.responses" :requests="recruit.requests"
                            :practice="recruit.practice" :allTitle="true"></tci-recruit-card>
        </v-row>
      </tci-title>
      <tci-contact-footer color="grey lighten-2"></tci-contact-footer>
    </div>
  </div>
</template>

<script>
// import TciRecruit from "@/components/TciRecruit.vue";
import TciTitle from "@/components//TciTitle.vue";
import TciContactFooter from "@/components/TciContactFooter.vue";
import TciRecruitCard from "@/components/TciRecruitCard.vue";

export default {
  name: "Recruit2019",
  props: {
    allTitle: Boolean
  },
  components: {
    "tci-title": TciTitle,
    "tci-contact-footer": TciContactFooter,
    "tci-recruit-card": TciRecruitCard
  },
  data: () => ({
    recruitInfo: [
      {
        "requests":[
          "计算机、软件、信息工程、数学等理工科专业，2024届毕业生；",
          "掌握JAVA、C语言或C#等基础知识，有相关数据库理论基础知识；",
          "有较强的学习能力、逻辑思维能力；有良好的沟通协调能力，主动合作的团队精神；",
          "性格开朗，热爱软件开发工作，具备较强的责任心、服务及质量意识，能在一定的压力下工作。",
          "有日语基础或对学习日语有浓厚的兴趣者优先采用。"

          ],"responses":[
            "参与项目的需求分析、设计及相关文档编写工作；","参与项目模块的设计与代码开发；","遵循公司技术标准、代码规范、文档规范；","可以长期全职实习，提供毕业转正（ 不接受兼职或短期实习 ）。"
          ],"practice":[
            "实习期补贴：本科150元-200元/工作日。 实习期间为实习生统一购买意外伤害险。",
            "实习转正待遇：月薪6K~9K，极优秀者9K~11K； 双休、1小时弹性工作制、带薪年假等。"
          ], "position":"苏州、常州"}
      ],
    recruitDeveloperInfo: [
      {
        "name": ".NET开发工程师",
        "requests":[
          "本科及以上学历，具有1~3 年 的C#开发实际经验；熟悉C/S和B/S结构。",
          "精通.Net Framework；熟练使用MVC、WebService 了解Java，Python，Android Studio等开发语言优先。",
          "熟练掌握JavaScript，熟悉CSS，了解HTTP协议。",
          "熟悉Sql server、Oracle、Mysql等主流数据库。",
          "对技术有较强的自我学习和提升能力、能快速融合企业团队文化，并有一定的抗压能力。"
        ],
        "responses":[
          "参与项目系统的需求沟通、设计与研发。",
          "按照设计要求和源代码编写规范编写程序代码，对其质量、性能负责。",
          "编写相关技术文档，负责进行开发阶段的软件测试。",
          "产品上线后，保障业务系统的稳定，解决相关技术问题。",
          "辅助项目经理，承担进度管理，品质管理，团队管理等管理工作。"
        ],
        "position":"苏州",
        "salary": "1k-15k",
        "email": "suzhou@trans-cosmos.com.cn"
      }
    ],
    recruitManagerInfo: [
      {
        "name": "项目开发负责人",
        "requests":[
          "大专及以上学历，计算机相关专业，3年以上开发经验，1年以上项目管理经验。",
          "具备Java,.NET,php,cobol其中一门语言相关开发知识和经验。",
          "熟悉B/S和C/S架构，拥有熟练的C#、php、.Net、JavaScript、Html等开发技术。",
          "具有良好规范的文档和编程习惯。",
          "熟悉MYSQL、SQL server或Oracle数据库分析与设计。",
          "具有良好的计划和执行能力、组织协调能力及人际沟通能力，善于分析解决问题，有责任心，有团队精神。",
          "有日语基础者优先考虑。"
        ],"responses":[
          "项目管理：制定项目计划与流程，安排开发人员工作，协调项目实施与验收，推进项目顺利交付上线。",
          "承担主要技术调研工作和技术提案，积极主动帮助辅导下属工作。",
          "对生产型的工厂业务有一定了解。"
        ],
        "position":"苏州",
        "salary": "1k-15k",
        "email": "suzhou@trans-cosmos.com.cn"
      }
    ],
    recruitServerEngineerInfo: [
      {
        "name": "项目经理",
        "requests":[
          "负责业务需求分析、功能设计、项目规划、WBS分解、测试文档的制作；",
          "跟踪项目进度，协调内/外部资源，解决项目推进过程中的课题&问题；",
          "明确团队&成员的任务内容及验收标准, 推进项目如期完成验收；",
          "跟踪控制项目成本，满足客户需求的前提下，完成预定项目目标；",
          "带领团队总结项目经验、知识归档，提升团队成员能力。"
        ],"responses":[
          "本科及以上学历，计算机相关专业；",
          "英语6级相当，能够跟客户交流无障碍、编写英文项目文档资料；",
          "3年以上开发经验，1年以上项目管理经验。",
          "具备较强的客户沟通交流和文档处理能力，良好的团队合作意识和较强的组织协调能力；",
          "有欧美现场工作或外包项目工作经验者优先。"
        ],
        "position":"苏州",
        "salary": "1k-15k",
        "email": "suzhou@trans-cosmos.com.cn"
      }
    ],
  })
};
</script>
